import { render } from "./foodItemDisplay.vue?vue&type=template&id=57b83268&scoped=true"
import script from "./foodItemDisplay.vue?vue&type=script&lang=js"
export * from "./foodItemDisplay.vue?vue&type=script&lang=js"

import "./foodItemDisplay.vue?vue&type=style&index=0&id=57b83268&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b83268"]])

export default __exports__